import * as Dialog from '@radix-ui/react-dialog'
import type { ReactNode } from 'react'
import { Heading } from '../Heading'
import { CloseIcon } from '../../../icons'

type ModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger?: ReactNode
  title: string
  className?: string
  children: ReactNode
}

export const Modal = ({ open, onOpenChange, trigger, children, title, className }: ModalProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange} modal={true}>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="ap:fixed ap:inset-0 ap:bg-surface-overlay ap:z-30" />
        <Dialog.Content
          aria-describedby="modal"
          className={`ap:fixed ap:flex ap:w-[calc(100vw-32px)] ap:min-w-0 ap:flex-col ap:bg-surface-background ap:overflow-y-auto ap:gap-xl ap:left-1/2 ap:top-1/2 ap:max-h-[90vh] ap:max-w-[90vw] ap:-translate-x-1/2 ap:-translate-y-1/2 ap:rounded-lg ap:p-2xl ap:z-40 ap:sm:w-auto ap:sm:min-w-[650px] ${className}`}
        >
          <div className="ap:flex ap:w-full ap:items-center ap:justify-between">
            <Dialog.Title>
              <Heading size="lg">{title}</Heading>
            </Dialog.Title>
            <button
              type="button"
              className="ap:text-content-secondary ap:bg-transparent ap:cursor-pointer ap:p-md ap:hover:bg-surface-primary-hover ap:rounded-full"
              onClick={() => onOpenChange(false)}
            >
              <CloseIcon />
            </button>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
